const TRAVEL_REPLACEMENT_REASON_MESSAGES = Object.freeze({
  allowance_disabled: 'Travel Replacement Workouts are disabled for your dojo.',
  allowance_exhausted: 'You have used all Travel Replacement Workouts available this year.',
  expired: 'This workout has expired.',
  has_progress: 'A workout with logged progress cannot be replaced.',
  terminal: 'Completed, rested, or already-replaced workouts cannot be replaced.',
  replacement_workout: 'A Travel Replacement Workout cannot be replaced again.',
  not_scheduled_obligation: 'Only workouts scheduled from your workout plan can use a Travel Replacement.',
  progress_started: 'A workout with logged progress cannot be replaced.',
  not_pending: 'Only an unstarted workout can be replaced.',
  already_replaced: 'This workout already has a Travel Replacement Workout.',
  rest: 'A Rest Day cannot also become a Travel Replacement Workout.',
  complete: 'A completed workout cannot be replaced.',
});

export const formatTravelReplacementReason = (reason, scope) => {
  if (reason === 'allowance_disabled' && scope === 'personal') {
    return 'Travel Replacement Workouts are disabled in your personal settings.';
  }
  return TRAVEL_REPLACEMENT_REASON_MESSAGES[reason]
    || 'This workout is not eligible for a Travel Replacement Workout.';
};
